export default __webpack_public_path__ + "static/media/intercom.8af67890.jpg";